var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMainFinix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 21,
    viewBox: "0 0 120 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h12.532v14.552H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.21c0 .669.53 1.21 1.185 1.21s1.186-.541 1.186-1.21C2.37.542 1.84 0 1.185 0 .531 0 0 .542 0 1.21",
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.038.06v.006A.224.224 0 0 0 .062.034a.333.333 0 0 0-.023.025",
    id: "f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.061.066V.06S.041.034.04.034C.038.034.043.042.06.066",
    id: "i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.061.066a.41.41 0 0 1 0-.006L.04.034C.038.034.043.042.06.066",
    id: "l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.663.968a2.195 2.195 0 0 1-.028.02h.012c.057.006.301.036.558.165a2.813 2.813 0 0 0-.15.15c-.004.002-.006.005-.009.008a2.803 2.803 0 0 0-.226.279l-.01.015a2.728 2.728 0 0 0-.092.139l-.008.012c-.03.05-.06.103-.088.156l-.006.012a2.81 2.81 0 0 0-.07.144l-.013.032a2.807 2.807 0 0 0-.13.368 2.695 2.695 0 0 0-.034.139l-.008.034a2.861 2.861 0 0 0-.03.172l-.005.036a2.799 2.799 0 0 0-.015.143l-.003.049a2.84 2.84 0 0 0-.003.313c0 .015.002.03.003.044v.003c.002.029.003.057.006.085l.006.053.01.078.008.055.013.074.01.056.017.07.013.057.02.07.015.054.038.113.025.066.02.051.028.068.02.046.034.068.02.041.037.07.02.036.043.072.014.024c.03.048.062.095.094.14l.012.017.08.107h.001a2.7 2.7 0 0 0 2.115 1.03c1.353 0 2.453 1.124 2.453 2.505 0 1.381-1.1 2.505-2.453 2.505-1.352 0-2.453-1.124-2.453-2.505 0-.526.16-1.014.433-1.417h-.001L.775 6.086A4.146 4.146 0 0 0 0 8.507c0 2.268 1.807 4.112 4.027 4.112s4.027-1.844 4.027-4.112a4.132 4.132 0 0 0-1.931-3.51s-.478-.26-1.14-.422a4.173 4.173 0 0 0-.956-.124 1.194 1.194 0 0 1-.716-.243L3.3 4.199a1.232 1.232 0 0 1-.063-.052l-.01-.01a1.23 1.23 0 0 1-.16-.176l-.024-.032a1.34 1.34 0 0 1-.084-.14l-.029-.061-.016-.035a1.213 1.213 0 0 1-.035-.098l-.01-.036a1.167 1.167 0 0 1-.026-.112 1.256 1.256 0 0 1-.012-.077l-.004-.036a1.28 1.28 0 0 1-.006-.114v-.014c0-.604.425-1.105.986-1.213.024-.005.048-.01.072-.013a.998.998 0 0 1 .981-.873c.548 0 .992.454.992 1.013l-.001.024c.014-.075.022-.153.024-.233l.002-.037-.002-.038a1.41 1.41 0 0 0-.1-.49 1.235 1.235 0 0 0-.241-.382A2.432 2.432 0 0 0 3.6 0c-.788 0-1.488.38-1.937.968",
    id: "o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.257 0c0 .06-.156 1.17-.787 2.283-.293.517-1.21 1.47-1.21 1.47l-.004.004A11.103 11.103 0 0 0 0 10.487c0 3.806 1.902 7.164 4.785 9.142l.008.007.01.006a.71.71 0 0 0 .036.019c.577.053 1.048.49 1.19 1.067l.006.013c.15-.157.275-.553.325-.727.032-.154.05-.342.03-.546-.092-.719-.642-1.106-.642-1.106a2.576 2.576 0 0 0-.074-.06v.001a9.451 9.451 0 0 1-4.099-7.816c0-2.153.713-4.14 1.91-5.727 0 0 1.088-.858 1.197-1.63 0 0 .83 1.463.201 2.771a7.637 7.637 0 0 0-1.519 4.586 7.617 7.617 0 0 0 3.114 6.163l-.002.003a22.006 22.006 0 0 1 2.278 2.144c.275.02.528.126.734.293.267.217.456.539.513.908l.002.003.006-.015c.06-.094.448-.756.05-1.855l-.003-.01c-.331-.833-1.308-1.724-1.992-2.273-.409-.328-.713-.535-.713-.535a6.002 6.002 0 0 1-2.412-4.826c0-1.117.302-2.164.828-3.059.1-.171 1.816-2.503-.225-5.607A146.335 146.335 0 0 1 4.257 0z",
    id: "r"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98 0c-.078.114-.363.523-1.286 1.821-2.04 3.104-.325 5.436-.224 5.607.525.895.828 1.942.828 3.06 0 1.981-.952 3.74-2.413 4.826 0 0-.304.206-.713.534-.684.55-1.66 1.44-1.991 2.274l-.004.009c-.397 1.099-.01 1.761.05 1.855L.233 20l.002-.003c.057-.37.246-.69.514-.908.206-.167.458-.274.733-.293a22.006 22.006 0 0 1 2.278-2.144l-.001-.003a7.617 7.617 0 0 0 3.113-6.163 7.637 7.637 0 0 0-1.518-4.585c-.629-1.31.201-2.773.201-2.773.108.773 1.196 1.631 1.196 1.631a9.482 9.482 0 0 1 1.911 5.727A9.452 9.452 0 0 1 4.568 18.3c-.002 0-.003.002-.005.003l-.057.046a1.966 1.966 0 0 0-.017.014s-.55.386-.642 1.105c-.021.204-.002.392.03.546.05.174.175.57.325.727l.005-.013c.142-.578.614-1.014 1.19-1.067a.72.72 0 0 0 .036-.019l.01-.006.009-.007a11.068 11.068 0 0 0 4.785-9.142c0-2.532-.843-4.868-2.256-6.73a1.114 1.114 0 0 1-.005-.003S7.06 2.8 6.766 2.283C6.136 1.17 5.98.059 5.98 0z",
    id: "u"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.001%",
    y2: "50%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05E75",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62838",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.49%",
    y1: "50.021%",
    x2: "61.516%",
    y2: "50.021%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.476%",
    y1: "49.992%",
    x2: "61.502%",
    y2: "49.992%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.413%",
    y1: "50%",
    x2: "61.497%",
    y2: "50%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72BA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A7DF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23B182",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BBF95",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.247 9.481c-.79.71-1.29 1.659-1.498 2.847h8.676c-.156-1.188-.59-2.137-1.303-2.847-.712-.709-1.64-1.064-2.787-1.064-1.268 0-2.298.355-3.088 1.064m9.236 4.643c-.225.222-.512.332-.86.332h-9.9c.191 1.242.743 2.244 1.655 3.007.911.762 2.027 1.144 3.348 1.144a4.97 4.97 0 0 0 1.628-.293c.564-.195 1.029-.434 1.394-.718.243-.195.53-.293.86-.293.33 0 .59.089.781.266.313.266.47.568.47.905 0 .319-.14.585-.418.798-.59.479-1.324.869-2.201 1.17-.878.302-1.716.452-2.514.452-1.425 0-2.702-.314-3.83-.944a6.774 6.774 0 0 1-2.645-2.62c-.634-1.118-.95-2.386-.95-3.805s.299-2.691.898-3.818A6.577 6.577 0 0 1 49.7 7.074c1.068-.63 2.28-.945 3.635-.945 1.337 0 2.492.302 3.465.905.972.603 1.72 1.446 2.24 2.527.522 1.082.782 2.324.782 3.725 0 .337-.113.616-.339.838M67.978 3.442c-.59.657-.886 1.526-.886 2.607v.719h2.658c.365 0 .66.106.886.319.225.213.338.497.338.851 0 .32-.113.586-.338.798-.226.213-.521.32-.886.32h-2.658V19.43c0 .408-.121.736-.364.985-.244.248-.583.372-1.017.372-.347 0-.647-.124-.898-.372-.252-.249-.378-.577-.378-.985V9.056h-1.12c-.365 0-.66-.107-.886-.32a1.051 1.051 0 0 1-.34-.798c0-.354.114-.638.34-.851.225-.213.52-.32.885-.32h1.12v-.452c0-1.259.248-2.363.743-3.312A5.384 5.384 0 0 1 67.262.795C68.156.272 69.177.01 70.323.01c.382 0 .699.116.951.346.252.23.378.524.378.878 0 .355-.126.648-.378.878-.252.23-.57.346-.951.346-.973 0-1.755.328-2.345.984M100.677 20.402c-.252-.257-.378-.58-.378-.97V7.591c0-.407.126-.735.378-.984.252-.248.569-.372.951-.372.4 0 .72.124.964.372.243.249.365.577.365.984v11.84c0 .39-.122.713-.365.97-.243.258-.564.386-.964.386-.382 0-.7-.128-.95-.386",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.468 6.236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.532 13.435c0 .32-.109.585-.326.798-.217.213-.5.32-.846.32-.417 0-.73-.142-.938-.426L6.279 9.072l-3.934 5.055c-.26.284-.573.425-.938.425-.348 0-.621-.106-.82-.319a1.12 1.12 0 0 1-.3-.798c0-.355.12-.683.364-.984L4.69 7.289.39 2.102C.13 1.782 0 1.446 0 1.09 0 .789.1.532.3.319.499.106.782 0 1.146 0c.417 0 .747.15.99.452L6.41 5.667 10.24.452c.226-.301.547-.452.964-.452.347 0 .621.11.82.333.2.222.3.492.3.811 0 .39-.121.745-.364 1.064L8.025 7.45l4.142 5.055c.243.266.365.576.365.931",
    fill: "#404041",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.465 20.402c-.252-.257-.377-.58-.377-.97V7.591c0-.407.125-.735.377-.984.252-.248.57-.372.951-.372.4 0 .721.124.964.372.243.249.365.577.365.984v11.84c0 .39-.122.713-.365.97-.243.258-.564.386-.964.386-.382 0-.699-.128-.95-.386M88.983 6.14a6.692 6.692 0 0 0-6.688 6.884c-.002.078-.003.156-.003.235v6.412A1.29 1.29 0 0 0 83.621 21c.4 0 .72-.126.964-.378.242-.25.364-.567.365-.947v-6.416c0-1.407.377-2.471 1.133-3.193.732-.698 1.696-1.057 2.892-1.08 1.196.023 2.16.382 2.892 1.08.756.722 1.133 1.786 1.133 3.193v6.412A1.289 1.289 0 0 0 94.33 21a1.29 1.29 0 0 0 1.328-1.33v-6.383a6.692 6.692 0 0 0-6.675-7.146M34.685 18.13c-2.494 0-4.523-2.072-4.523-4.618 0-2.546 2.029-4.618 4.523-4.618 2.493 0 4.522 2.072 4.522 4.618 0 2.546-2.029 4.618-4.522 4.618m7.063-4.008a7.449 7.449 0 0 0 .001-1.212V1.294c0-.71-.563-1.286-1.259-1.286-.695 0-1.258.576-1.258 1.286v6.669a6.97 6.97 0 0 0-4.547-1.69c-3.91 0-7.09 3.247-7.09 7.239 0 3.991 3.18 7.239 7.09 7.239 3.643 0 6.653-2.822 7.045-6.437a1.32 1.32 0 0 0 .018-.192",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.597 9.277)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.21c0 .669.53 1.21 1.185 1.21s1.186-.541 1.186-1.21C2.37.542 1.84 0 1.185 0 .531 0 0 .542 0 1.21",
    fill: "url(#d)",
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.594 2.504)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.038.06v.006A.224.224 0 0 0 .062.034a.333.333 0 0 0-.023.025",
    fill: "url(#g)",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.21 6.814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.061.066V.06S.041.034.04.034C.038.034.043.042.06.066",
    fill: "url(#j)",
    mask: "url(#k)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.938 2.507)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.061.066a.41.41 0 0 1 0-.006L.04.034C.038.034.043.042.06.066",
    fill: "url(#m)",
    mask: "url(#n)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0637C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.632 2.565v.007c.052-.07 0-.007 0-.007M8.27 6.882v-.007s-.05-.063 0 .007M3 2.568s-.053-.064 0 .006v-.006"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.756 1.98)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.663.968a2.195 2.195 0 0 1-.028.02h.012c.057.006.301.036.558.165a2.813 2.813 0 0 0-.15.15c-.004.002-.006.005-.009.008a2.803 2.803 0 0 0-.226.279l-.01.015a2.728 2.728 0 0 0-.092.139l-.008.012c-.03.05-.06.103-.088.156l-.006.012a2.81 2.81 0 0 0-.07.144l-.013.032a2.807 2.807 0 0 0-.13.368 2.695 2.695 0 0 0-.034.139l-.008.034a2.861 2.861 0 0 0-.03.172l-.005.036a2.799 2.799 0 0 0-.015.143l-.003.049a2.84 2.84 0 0 0-.003.313c0 .015.002.03.003.044v.003c.002.029.003.057.006.085l.006.053.01.078.008.055.013.074.01.056.017.07.013.057.02.07.015.054.038.113.025.066.02.051.028.068.02.046.034.068.02.041.037.07.02.036.043.072.014.024c.03.048.062.095.094.14l.012.017.08.107h.001a2.7 2.7 0 0 0 2.115 1.03c1.353 0 2.453 1.124 2.453 2.505 0 1.381-1.1 2.505-2.453 2.505-1.352 0-2.453-1.124-2.453-2.505 0-.526.16-1.014.433-1.417h-.001L.775 6.086A4.146 4.146 0 0 0 0 8.507c0 2.268 1.807 4.112 4.027 4.112s4.027-1.844 4.027-4.112a4.132 4.132 0 0 0-1.931-3.51s-.478-.26-1.14-.422a4.173 4.173 0 0 0-.956-.124 1.194 1.194 0 0 1-.716-.243L3.3 4.199a1.232 1.232 0 0 1-.063-.052l-.01-.01a1.23 1.23 0 0 1-.16-.176l-.024-.032a1.34 1.34 0 0 1-.084-.14l-.029-.061-.016-.035a1.213 1.213 0 0 1-.035-.098l-.01-.036a1.167 1.167 0 0 1-.026-.112 1.256 1.256 0 0 1-.012-.077l-.004-.036a1.28 1.28 0 0 1-.006-.114v-.014c0-.604.425-1.105.986-1.213.024-.005.048-.01.072-.013a.998.998 0 0 1 .981-.873c.548 0 .992.454.992 1.013l-.001.024c.014-.075.022-.153.024-.233l.002-.037-.002-.038a1.41 1.41 0 0 0-.1-.49 1.235 1.235 0 0 0-.241-.382A2.432 2.432 0 0 0 3.6 0c-.788 0-1.488.38-1.937.968",
    fill: "url(#p)",
    mask: "url(#q)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.257 0c0 .06-.156 1.17-.787 2.283-.293.517-1.21 1.47-1.21 1.47l-.004.004A11.103 11.103 0 0 0 0 10.487c0 3.806 1.902 7.164 4.785 9.142l.008.007.01.006a.71.71 0 0 0 .036.019c.577.053 1.048.49 1.19 1.067l.006.013c.15-.157.275-.553.325-.727.032-.154.05-.342.03-.546-.092-.719-.642-1.106-.642-1.106a2.576 2.576 0 0 0-.074-.06v.001a9.451 9.451 0 0 1-4.099-7.816c0-2.153.713-4.14 1.91-5.727 0 0 1.088-.858 1.197-1.63 0 0 .83 1.463.201 2.771a7.637 7.637 0 0 0-1.519 4.586 7.617 7.617 0 0 0 3.114 6.163l-.002.003a22.006 22.006 0 0 1 2.278 2.144c.275.02.528.126.734.293.267.217.456.539.513.908l.002.003.006-.015c.06-.094.448-.756.05-1.855l-.003-.01c-.331-.833-1.308-1.724-1.992-2.273-.409-.328-.713-.535-.713-.535a6.002 6.002 0 0 1-2.412-4.826c0-1.117.302-2.164.828-3.059.1-.171 1.816-2.503-.225-5.607A146.335 146.335 0 0 1 4.257 0z",
    fill: "url(#s)",
    mask: "url(#t)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.98 0c-.078.114-.363.523-1.286 1.821-2.04 3.104-.325 5.436-.224 5.607.525.895.828 1.942.828 3.06 0 1.981-.952 3.74-2.413 4.826 0 0-.304.206-.713.534-.684.55-1.66 1.44-1.991 2.274l-.004.009c-.397 1.099-.01 1.761.05 1.855L.233 20l.002-.003c.057-.37.246-.69.514-.908.206-.167.458-.274.733-.293a22.006 22.006 0 0 1 2.278-2.144l-.001-.003a7.617 7.617 0 0 0 3.113-6.163 7.637 7.637 0 0 0-1.518-4.585c-.629-1.31.201-2.773.201-2.773.108.773 1.196 1.631 1.196 1.631a9.482 9.482 0 0 1 1.911 5.727A9.452 9.452 0 0 1 4.568 18.3c-.002 0-.003.002-.005.003l-.057.046a1.966 1.966 0 0 0-.017.014s-.55.386-.642 1.105c-.021.204-.002.392.03.546.05.174.175.57.325.727l.005-.013c.142-.578.614-1.014 1.19-1.067a.72.72 0 0 0 .036-.019l.01-.006.009-.007a11.068 11.068 0 0 0 4.785-9.142c0-2.532-.843-4.868-2.256-6.73a1.114 1.114 0 0 1-.005-.003S7.06 2.8 6.766 2.283C6.136 1.17 5.98.059 5.98 0z",
    fill: "url(#v)",
    mask: "url(#w)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMainFinix);
export default __webpack_public_path__ + "static/media/logo_main_finix.7b90f45f.svg";
export { ForwardRef as ReactComponent };